import educationOptions from "./educationOptions";
import employmentOptions from "./employmentOptions";
import genderOptions from "./genderOptions";


const registerData = [
  {
    tag: "input",
    type: "text",
    name: "fullName",
    placeholder: "Full Name *",
  },
  {
    tag: "input",
    type: "text",
    name: "age",
    placeholder: "Age *",
  },
  {
    tag: "select",
    type: "select",
    name: "gender",
    placeholder: "Select your Gender *",
    options: [...genderOptions],
  },
  {
    tag: "select",
    type: "select",
    name: "education",
    placeholder: "Select your Education *",
    options: [...educationOptions],
  },
  {
    tag: "select",
    type: "select",
    name: "employmentStatus",
    placeholder: "Select your Employment status *",
    options: [...employmentOptions],
  },

  {
    tag: "input",
    type: "text",
    name: "locationProvince",
    placeholder: "Location province *",
  },
  {
    tag: "input",
    type: "telephone",
    name: "phoneNumber",
    placeholder: "Phone Number *",
  },
  {
    tag: "input",
    type: "email",
    name: "email",
    placeholder: "Email *",
  },
  {
    tag: "input",
    type: "password",
    name: "password",
    placeholder: "Password *",
  },
  {
    tag: "input",
    type: "password",
    name: "confirmPassword",
    placeholder: "Confirm Password *",
  },
];

export default registerData;
